import React, { Component } from "react";
import pubsub from "pubsub-js";
import { Checkbox } from "@mui/material/";
import { Dropdown, List, Modal } from "semantic-ui-react";
import { InputGroup, Input, Card, CardBody } from "reactstrap";
import { Button, Row, Col } from "reactstrap";
import { Redirect } from "react-router";
import { connect } from "react-redux";
import { Badge, Empty } from "antd";
import axios from "axios";
import ToggleState from "../Common/ToggleState";
import TriggerResize from "../Common/TriggerResize";
import ToggleFullscreen from "../Common/ToggleFullscreen";
import HeaderRun from "./Header.run";
// import smallIMG from "./../../../resources/LogoSCL-small.png";
// import smallIMG from "./../../../resources/Favicon.png";
// import largeIMG from "./../../../resources/logoLarge.png";
import smallIMG from "./../../../resources/small2.png";
import largeIMG from "./../../../resources/nav_logo.png";
import { Link, withRouter } from "react-router-dom";
import Authentication from "../../../../src/services/Authentication.js";
import { SetNewListGroups } from "./../../../state/actions/Header/";
import SessionStorage from "./../../../services/SessionStorage";
import { Services } from "../../../repositories/clients/Services.js";
import { Drawer } from "@material-ui/core";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { withStyles } from "@material-ui/core/styles";

import "./style.scss";

import i18n from "../../../i18n";
import { withNamespaces } from "react-i18next";

const auth = new Authentication();
const session = new SessionStorage();

const styles = (theme) => ({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
  paper: {
    background: "white",
    // background: "#fefefec9"
  },
});

const iconSelect = {
  2: "https://magiclog.blob.core.windows.net/europartnerspic/Icono_purchase-order.svg",
  1: "https://magiclog.blob.core.windows.net/europartnerspic/Icono_ordenes-de-transporte.svg",
  3: "https://magiclog.blob.core.windows.net/europartnerspic/Icono_trazabilidad-de-embarques.svg",
};

class Header extends Component {
  constructor(props) {
    super(props);
    // i18n.changeLanguage(this.props.lang)
    i18n.changeLanguage("EN");
    this.state = {
      redirect: false,
      open: false,
      openselect: false,
      dataDrop: [],
      dataDrop1: [],
      notify: this.props.notify,
      nit: this.props.nit,
      clients: this.props.clients,
      lang: this.props.lang,
      checkAll: true,
      rolId: auth.getAuthentication("RolId"),
      cout: 0,

      openModal: false,
      openDrop: false,
      isMobil: false,
    };
  }
  componentDidMount() {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);

    const data = this.props.group_list;

    let cout = 0;
    data.map((e) => {
      e.data.map((f) => {
        f.hidden = false;
        if (f.check) {
          cout = cout + 1;
        }
        return f;
      });
      return e;
    });
    this.setState(
      {
        dataDrop: [...data] ? [...data] : [],
        dataDrop1: [...data] ? [...data] : [],
        cout,
        isMobil: isMobileDevice,
      },
      () => {},
    );
    HeaderRun();
  }
  /*=============================================
    =            Handle Togle User Block         =
    =============================================*/
  toggleUserblock(e) {
    e.preventDefault();
    pubsub.publish("toggleUserblock");
  }
  handleLogOut = () => {
    const createOffsetValue = (date) => {
      var sign = date.getTimezoneOffset() > 0 ? "-" : "+";
      var offset = Math.abs(date.getTimezoneOffset());
      var hours = Math.floor(offset / 60);
      var minutes = ((offset % 60) / 60) * 10;
      return sign + hours + "." + minutes;
    };

    let endSession = {
      SessionId: auth.getAuthentication("token"),
      EndConnection: new Date(),
      timezone: createOffsetValue(new Date()),
      Logout: "1",
    };
    //TODO
    axios.post(`${Services.AUDIT.path}user-logs/logout`, endSession);
  };

  removeToken = () => {
    this.handleLogOut();
    auth.deleteAuthentication("token");
    auth.deleteAuthentication("dataUser");
    auth.deleteAuthentication("customerSelect");
    session.deleteItem("clients");
    session.deleteItem("nit");
    session.deleteItem("lang");
    session.deleteItem("group_list");
    this.props.history.push("/");
  };

  handleSearch = (event) => {
    let { search } = this.state;
    search = event.target.value;
    let haveSearch = false;
    if (search.length > 0) {
      haveSearch = true;
    }
    let all = [...this.state.dataDrop];
    let newAll = all.map((e) => {
      let newE = { ...e };

      let newData2 = newE.data.map((item) => {
        const nameData = item.value
          ? item.value.toUpperCase()
          : "".toUpperCase();
        const nameNIT = item.NIT ? item.NIT.toUpperCase() : "".toUpperCase();
        const idData = item.id
          ? item.id.toString().toUpperCase()
          : "".toUpperCase();
        const textData = search.toUpperCase();

        if (
          nameData.indexOf(textData) > -1 ||
          idData.indexOf(textData) > -1 ||
          nameNIT.indexOf(textData) > -1
        ) {
          item.hidden = false;
        } else {
          item.hidden = haveSearch ? true : false;
        }
        return item;
      });
      newE.data = newData2;
      return newE;
    });
    let finalAll = newAll.filter((item) => {
      return item.data.length > 0;
    });
    this.setState({ dataDrop: finalAll, search });
  };

  handeInputData = (event) => {
    this.setState({ searchValue: event.target.value });
  };

  checkGroup = (index, all, uncheck) => {
    let newData = this.state.dataDrop;
    if (all) {
      if (uncheck) {
        newData[index].check = false;
        newData[index].data.map((e) => {
          e.check = false;
          return e;
        });
      } else {
        newData[index].check = true;
        newData[index].data.map((e) => {
          e.check = true;
          return e;
        });
      }
    } else {
      newData[index].check = !newData[index].check;
      newData[index].data.map((e) => {
        e.check = newData[index].check;
        return e;
      });
    }

    let cout = 0;
    newData.map((e) => {
      e.data.map((f) => {
        if (f.check) {
          cout = cout + 1;
        }
        return f;
      });
      return e;
    });

    this.setState({ dataDrop: newData, cout });
  };

  getCheck = async () => {
    let clientes = [];
    let NIT = [];
    this.state.dataDrop.map((e) => {
      e.data.map((f) => {
        if (f.check) {
          clientes.push(f.id);
          NIT.push(f.NIT);
        }
        f.hidden = false;
        return f;
      });
      return e;
    });
    this.setState({
      openDrop: false,
      openModal: false,
      // openselect: false,
      search: "",
      clientes,
      NIT,
    });
    session.updateItem("clients", JSON.stringify(clientes));
    session.updateItem("nit", JSON.stringify(NIT));
    session.updateItem("group_list", JSON.stringify(this.state.dataDrop));
    session.addItem("notify", JSON.stringify(this.state.notify));

    await this.props.SetNewListGroups({
      group_list: this.state.dataDrop,
      clients: clientes,
      nit: NIT,
      notify: this.state.notify,
    });

    this.props.changeProps();
  };

  change = () => {
    // this.setState({ openselect: false });
    this.setState({ openDrop: false, openModal: false });
  };

  checkClient = (index, ind) => {
    let newData = this.state.dataDrop;
    newData[index].data[ind].check = !newData[index].data[ind].check;
    if (!newData[index].data[ind].check) {
      newData[index].check = false;
    }
    let cout = 0;
    newData.map((e) => {
      e.data.map((f) => {
        if (f.check) {
          cout = cout + 1;
        }
        return f;
      });
      return e;
    });

    this.setState({ dataDrop: newData, cout });
  };

  checkAll = () => {
    if (!this.state.checkAll) {
      let newData = this.state.dataDrop;
      newData.map((e, index) => {
        this.checkGroup(index, true, false);
        return e;
      });
      this.setState({ checkAll: true });
    } else {
      let newData = this.state.dataDrop;
      newData.map((e, index) => {
        this.setState({ checkAll: false });
        this.checkGroup(index, true, true);
        return e;
      });
    }
  };

  redirectModule = async (idComment, idMovimiento, path, viewComment) => {
    console.log(
      "idComment,idMovimiento,path",
      idComment,
      idMovimiento,
      path,
      viewComment,
    );

    let { clients, nit, dataDrop } = this.state;

    if (viewComment === 0) {
      let UserId = auth.getAuthentication("dataUser");
      console.log("toca actualizar la data ", UserId);
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      let data = {
        CommentId: idComment,
        UserId: UserId,
        timezone: timezone,
        lang: this.props.lng,
      };
      this.props.history.push(
        `${path}${idMovimiento}?nofify=true&idComment=${idComment}`,
      );

      axios
        .put(`${Services.ADMIN.path}mencion/updateView`, data)
        .then((response) => {
          let newNotify = response.data.Notify;
          session.addItem("notify", JSON.stringify(newNotify));
          session.updateItem("clients", JSON.stringify(clients));
          session.updateItem("nit", JSON.stringify(nit));
          session.updateItem("group_list", JSON.stringify(dataDrop));
          this.setState(
            {
              notify: newNotify,
              open: false,
            },
            () => {
              console.log("se actualizo la data");
              this.props.SetNewListGroups({
                group_list: dataDrop,
                clients: clients,
                nit: nit,
                notify: newNotify,
              });
              console.log("se actualizo el reducer");

              // this.props.history.push(`${path}${idMovimiento}?nofify=true`);
            },
          );
        })
        .catch((error) => {
          console.warn(error);
        });
    } else {
      this.setState({ open: false }, () => {
        this.props.history.push(
          `${path}${idMovimiento}?nofify=true&idComment=${idComment}`,
        );
        console.log("solo es redireccionamiento");
      });
    }
  };
  getNotify = () => {
    let { notify } = this.state;
    let items = notify.map((e, index) => {
      return (
        <Card
          className={` col-12 myCardNofify  ${
            e.ReadComment === "0" ? "notifyNoView" : "notifyView"
          } `}
        >
          <CardBody
            onClick={() =>
              this.redirectModule(
                e.CommentId,
                e.RowId,
                e.Url,
                Number(e.ReadComment),
              )
            }
            className="cardBodyNotify"
          >
            <div className="row pointerNotify">
              <spam className="col-1">
                <img
                  alt=""
                  src={iconSelect[e.ModuleId]}
                  height="25"
                  width="25"
                  style={{ marginTop: "-9 px" }}
                ></img>
              </spam>

              <label className="col-8 pointerNotify">
                <spam id="NameMencion" className="userThatMentioned">
                  {e.User}
                </spam>{" "}
                {this.props.t("mention_notification")} {e.Module}{" "}
                <spam id="noMovimiento" className="">
                  {e.Referencia}
                </spam>
              </label>
              <spam
                style={{ fontSize: "11px", textAlign: "end" }}
                className="col-3 pointerNotify"
              >
                {e.CreationDate}
              </spam>
            </div>
          </CardBody>
        </Card>
      );
    });

    return items;
  };

  toggleDrawer = (open) => (event) => {
    // if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
    //   return;
    // }
    this.setState({ open });
    // setDrawer(open);
  };

  render() {
    // let { redirect, searchValue, dataDrop, checkAll, cout, open, notify } = this.state;
    let {
      redirect,
      searchValue,
      dataDrop,
      checkAll,
      cout,
      notify,
      open,
      isMobil,
      openDrop,
      openModal,
    } = this.state;

    let countBadge = 0;

    for (let i = 0; i < notify.length; i++) {
      const e = notify[i];
      if (e.ReadComment === "0") countBadge = countBadge + 1;
    }

    if (redirect) return <Redirect to="/login" />;
    let acction;
    const { classes } = this.props;

    if (searchValue === "" || searchValue === undefined) {
    } else {
      acction = (
        <Link
          to={`/search/${encodeURIComponent(
            searchValue.replace(/[&\\#,+()$~%'":*?<>{}]/g, ""),
          )}`}
        >
          <button className="d-none" type="submit">
            Submit
          </button>
        </Link>
      );
    }
    if (dataDrop && dataDrop.length > 0) {
      dataDrop.forEach((data) => {
        data.value = data.value === "Entities" ? "Entidades" : data.value;
      });
    }
    return (
      <header className="topnavbar-wrapper">
        {/* START Top Navbar */}
        <nav className="navbar topnavbar">
          {/* START navbar header */}
          <div className="navbar-header" style={{ height: "inherit" }}>
            <a className="navbar-brand" href="/dashboard">
              <div className="brand-logo" style={{ padding: "0px" }}>
                <img
                  className="img-fluid"
                  src={largeIMG}
                  alt="App Logo"
                  style={{
                    // marginRight: "1em",
                    // maxWidth: "62%",
                    marginTop: "-.7em",
                    width: "10em",
                  }}
                />
              </div>
              <div className="brand-logo-collapsed">
                <img className="img-fluid" src={smallIMG} alt="App Logo" />
                {/* <img
                  className="img-fluid"
                  src={largeIMG}
                  alt="App Logo"
                  style={{ marginRight: "1em" }} 
                />*/}
              </div>
            </a>
          </div>
          {/* END navbar header */}
          {/* START Left navbar */}
          <ul
            className="navbar-nav mr-auto flex-row"
            style={{ height: "inherit" }}
          >
            <li className="nav-item icono-nav-basicpartner">
              {/* Button used to collapse the left sidebar. Only visible on tablet and desktops */}
              <TriggerResize>
                <ToggleState state="aside-collapsed">
                  <span
                    title={this.props.t("menu")}
                    style={{ cursor: "pointer" }}
                    className="nav-link"
                  >
                    <em className="fas fa-bars"></em>
                  </span>
                </ToggleState>
              </TriggerResize>
              {/* Button to show/hide the sidebar on mobile. Visible on mobile only. */}
              <ToggleState state="aside-toggled" nopersist={true}>
                <span
                  style={{ cursor: "pointer" }}
                  className="nav-link sidebar-toggle d-md-none"
                >
                  <em className="fas fa-bars"></em>
                </span>
              </ToggleState>
            </li>
            {/* START User avatar toggle */}
            <li
              className="nav-item d-none d-md-block icono-nav-basicpartner"
              // className="nav-item"
            >
              <span
                style={{ cursor: "pointer" }}
                id="user-icon-nav"
                title={this.props.t("user")}
                className="nav-link"
                onClick={this.toggleUserblock}
              >
                <em
                  className="icon-icono_usuario-1"
                  style={{ fontSize: "1.5em" }}
                ></em>
              </span>
            </li>

            {/* <h2
              className="nav-link"
              style={{ color: '#fff', fontWeight: '100' }}
              href=" "
              data-search-open=""
            >
              |
            </h2> */}

            <li
              // className="nav-item d-none d-md-block icono-nav-basicpartner"
              className="nav-item"
            >
              <button
                style={{ paddingRight: "0px", marginTop: "5px", color: "#fff" }}
                // className="nav-link"
                onClick={() => {
                  this.setState({
                    openselect: !this.state.openselect,
                  });
                }}
              >
                <em
                  href=" "
                  title={this.props.t("customer_filter")}
                  id="company-icon"
                  className="pointerSelect big-icon"
                  style={{ paddingRight: "0px", fontSize: "1.5em" }}
                  // style={{ marginTop: '-8px' }}
                  onClick={() => {
                    this.setState({
                      // openselect: !this.state.openselect,
                      openDrop: isMobil ? false : !openDrop,
                      openModal: isMobil ? !openDrop : false,
                    });
                  }}
                >
                  <em
                    style={
                      {
                        // color: "#ffff",
                        // marginLeft: "10px",
                        // marginRight: "20px",
                      }
                    }
                    className="icon-icono_entidades pointerSelect2 select-customer "
                  ></em>
                  <i
                    className="select-customer"
                    style={{
                      // color: "#ffff",
                      fontSize: "11px",
                      marginLeft: "4px",
                      fontStyle: "normal",
                    }}
                  >
                    ▼
                  </i>
                </em>
                <div
                  style={{
                    background: "#FFF",
                    width: "876px",
                    height: "330px",
                    position: "absolute",
                    top: "36px",
                    left: "340px",
                    textAlign: "start",
                    border: "1px solid rgba(34,36,38,.15)",
                    boxShadow: "0 2px 3px 0 rgba(34,36,38,.15)",
                  }}
                  hidden={!openDrop}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <InputGroup style={{ width: "556px" }}>
                      <Input
                        value={this.state.search}
                        style={{
                          marginLeft: "23px",
                          marginTop: "21px",
                          height: "29px",
                        }}
                        placeholder={this.props.t("customer")}
                        onChange={(evt) => {
                          console.log(evt);
                          this.handleSearch(evt);
                        }}
                      />
                      <br></br>

                      <div style={{ width: "2em" }}></div>
                      <h5
                        style={{
                          color: "#0e0e0e",
                          marginTop: "24px",
                          fontWeight: "bold",
                        }}
                      >
                        {this.props.t("selected_customers")}: {cout}
                      </h5>
                    </InputGroup>
                  </div>
                  <div
                    style={{
                      textAlign: "right",
                      marginRight: "23px",
                      marginTop: "-33px",
                    }}
                  >
                    <Button
                      color="terceareo"
                      className="button "
                      style={{
                        color: "#fff",
                        backgroundColor: "#085fb0",
                        width: "4em",
                      }}
                      onClick={this.getCheck}
                    >
                      <div className="pt-1">✓</div>
                    </Button>{" "}
                    <Button
                      color="secondary"
                      className="button "
                      style={{
                        backgroundColor: "#999999",
                        color: "#fff",
                        width: "4em",
                      }}
                      onClick={this.change}
                    >
                      x
                    </Button>{" "}
                  </div>
                  <div class="ui divider"></div>
                  <div style={{ overflowY: "scroll", height: "230px" }}>
                    <List
                      style={{
                        color: "black",
                        fontSize: "13px",
                        fontWeight: "bold",
                        marginBottom: "0px",
                      }}
                      as="ol"
                    >
                      <List.Item as="li" value="">
                        <Checkbox
                          checked={checkAll}
                          onChange={this.checkAll}
                          value={""}
                        />
                        {this.props.t("select_all")}
                      </List.Item>
                    </List>
                    {/* <Dropdown.Divider /> */}
                    <div>
                      <List
                        style={{
                          color: "black",
                          fontSize: "13px",
                          fontWeight: "bold",
                        }}
                        as="ol"
                      >
                        {dataDrop.map((e, index) => {
                          if (e.hidden) {
                            return <></>;
                          } else {
                            return (
                              <div style={{ marginTop: "-10px" }}>
                                {/* <List.Item as="li" value="">
                                         <Checkbox
                                          checked={e.check}
                                          onChange={() => { this.checkGroup(index) }
                                          }
                                          key={index}
                                          value={e.id}
                                        /> 
                                      {e.value}*/}
                                <List.Item as="ol">
                                  {!openDrop ? (
                                    <></>
                                  ) : (
                                    e.data.map((f, ind) => {
                                      if (f.hidden) {
                                        return <></>;
                                      } else {
                                        return (
                                          <div
                                            className="squaredThree"
                                            style={{
                                              fontWeight: "initial",
                                              fontSize: "12px",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              value={f.id}
                                              onChange={() => {
                                                this.checkClient(index, ind);
                                              }}
                                              id={"squaredThree" + ind}
                                              name="check"
                                              checked={f.check}
                                            />

                                            <label for={"squaredThree" + ind}>
                                              <em
                                                style={{
                                                  color: "#F5F5F6",
                                                  margin: "2px",
                                                }}
                                                className="fas fa-check"
                                              ></em>
                                            </label>
                                            {/* <span style={{ marginLeft: "10px" }}> {f.NIT} -- {f.value}</span> */}
                                            <span
                                              style={{
                                                marginLeft: "10px",
                                              }}
                                            >
                                              {" "}
                                              {f.value}
                                            </span>
                                          </div>
                                        );

                                        // <div
                                        // style={{
                                        //   fontWeight: 'initial',
                                        //   fontSize: '12px',
                                        //   marginBottom: "10px"
                                        // }} >
                                        // <input
                                        //   type={"checkbox"}
                                        //   checked={f.check}
                                        //   style={{
                                        //     color: "#020e3a",
                                        //     backgroundColor: "#020e3a",
                                        //     display: "none"
                                        //   }}
                                        //   onChange={() => {
                                        //     this.checkClient(
                                        //       index,
                                        //       ind
                                        //     )
                                        //   }}
                                        //   value={f.id}
                                        // />

                                        //   {f.NIT} -- {f.value}
                                        // </div>
                                        // return (
                                        //   <List.Item
                                        //     style={{
                                        //       fontWeight: 'initial',
                                        //       fontSize: '12px',
                                        //     }}
                                        //     as="li"
                                        //     value=""
                                        //   >
                                        //     <Checkbox
                                        //       checked={f.check}
                                        //       onChange={() => {
                                        //         this.checkClient(
                                        //           index,
                                        //           ind
                                        //         )
                                        //       }
                                        //       }
                                        //       value={f.id}
                                        //     />{' '}
                                        //     {f.NIT} -- {f.value}
                                        //   </List.Item>
                                        // );
                                      }
                                    })
                                  )}
                                </List.Item>
                                {/*  </List.Item> */}
                                {index + 1 !== dataDrop.length ? (
                                  <Dropdown.Divider />
                                ) : (
                                  <></>
                                )}
                              </div>
                            );
                          }
                        })}
                      </List>
                    </div>
                  </div>
                </div>
                {/* Clientes */}

                {/* </em> */}
              </button>
            </li>
            <li className="nav-item">
              <span
                className="nav-link"
                style={{ cursor: "pointer" }}
                // style={{ paddingLeft: isMobil ? "0px" : "", paddingRight: isMobil ? "0px" : "" }}
                // href=" "

                data-search-open=""
              >
                <em
                  className="icon-final-21"
                  title={this.props.t("quick_search")}
                ></em>
              </span>
            </li>
          </ul>
          {/* <div style={{ width: "120px" }}></div> */}
          <ul className="navbar-nav flex-row" style={{ height: "inherit" }}>
            <li
              // QUITAR PARA FUNCIONALIDAD DE NOTIFICACIONES
              style={{ display: "none" }}
              // className="nav-item d-none d-md-block"
              className="nav-item"
            >
              {/* <a
                className="nav-link"
                style={{ paddingLeft: isMobil ? "3px" : "", paddingRight: isMobil ? "3px" : "" }}
                // href=" "
                data-search-open=""
              >
                <em
                  onClick={this.toggleDrawer(true)}
                  className="far fa-bell bellStyle"
                ></em>
              </a> */}
              <span
                style={{ cursor: "pointer" }}
                title={this.props.t("notification")}
                className="nav-link"
              >
                <Badge
                  size="small"
                  color={"#25b9ec"}
                  offset={[4, -3]}
                  count={countBadge}
                  style={{ color: "#2B3A56", fontWeight: "bold" }}
                >
                  <em
                    onClick={this.toggleDrawer(true)}
                    className="far fa-bell bellStyle"
                  ></em>
                </Badge>
              </span>
            </li>
            <li className="nav-item d-none d-md-block">
              {isMobil ? (
                <SwipeableDrawer
                  // container={container}
                  anchor="right"
                  open={open}
                  onClose={this.toggleDrawer(false)}
                  onOpen={this.toggleDrawer(true)}
                  // swipeAreaWidth={drawerBleeding}
                  disableSwipeToOpen={false}
                  ModalProps={{
                    keepMounted: true,
                  }}
                  sx={{
                    display: { xs: "block", sm: "none" },
                    "& .MuiDrawer-paper": {
                      boxSizing: "border-box",
                      width: window.innerWidth,
                    },
                  }}
                >
                  <div className="col-12 pt-3">
                    <div className="d-flex justify-content-end">
                      <i
                        className="fas fa-times-circle"
                        onClick={this.toggleDrawer(false)}
                      ></i>
                    </div>
                    <div className="d-flex justify-content-center row">
                      <em className="far fa-bell styleEmTitle"></em>
                      <h3 className="titleNotify">
                        {this.props.t("notifications")}
                      </h3>
                    </div>
                    <div className="d-flex justify-content-center ">
                      {notify.length <= 0 ? (
                        <Empty className="pt-5" />
                      ) : (
                        this.getNotify()
                      )}
                    </div>
                  </div>
                  {/* <div className="divcenter" >
                  <em className="far fa-bell styleEmTitle" ></em>
                  <h3 className="titleNotify">Notificaciones</h3>
                </div>
                <div className="banerNotify">{
                  notify.length <= 0
                    ?
                    <Empty style={{ padding: '3em 0px 0px 0px' }} /> :
                    this.getNotify()
                }</div> */}
                </SwipeableDrawer>
              ) : (
                <Drawer
                  anchor={"right"}
                  open={open}
                  classes={{ paper: classes.paper }}
                  onClose={this.toggleDrawer(false)}
                >
                  <div className="divcenter">
                    <em className="far fa-bell styleEmTitle"></em>
                    <h3 className="titleNotify">
                      {this.props.t("notifications")}
                    </h3>
                  </div>
                  <div className="banerNotify">
                    {notify.length <= 0 ? (
                      <Empty style={{ padding: "3em 0px 0px 0px" }} />
                    ) : (
                      this.getNotify()
                    )}
                  </div>
                </Drawer>
              )}
              {/*
            LENGUAJE##########
            <li
              style={{ paddingTop: "10px" }}
              className="nav-item"
            >
              {/* <DropdownAntd className="nav-link" overlay={this.state.menu}>
                <em class="fas fa-globe" style={{ fontSize: "15px", color: "white" }}></em>
              </DropdownAntd> */}
              {/* 
              <ReactFlagsSelect
                fullWidth={false}

                selectedSize={15}
                optionsSize={15}
                selected={this.state.lang}
                onSelect={this.changeLanguage}
                countries={["US", "MX"]}
                showSelectedLabel={false}
                showOptionLabel={false}
              /> */}
            </li>
            <li
              className="nav-item d-none d-md-block"
              // className="nav-item"
            >
              {/* <a
                className="nav-link"
                style={{ paddingLeft: isMobil ? "3px" : "", paddingRight: isMobil ? "3px" : "" }}
                onClick={this.removeToken}
                // href=" "
                data-search-open=""
              >
                <em className="icon-final-22"></em>
              </a> */}
              <span
                onClick={this.removeToken}
                style={{ cursor: "pointer" }}
                title={this.props.t("logout")}
                className="nav-link"
              >
                <em className="icon-final-22"></em>
              </span>
            </li>
            <li className="nav-item d-none d-md-block">
              <ToggleFullscreen
                title={this.props.t("fullscreen")}
                className="nav-link"
              />
            </li>
          </ul>
          <form style={{ height: "inherit" }} className="navbar-form">
            <div className="form-group">
              <input
                className="form-control"
                type="text"
                onChange={this.handeInputData}
                placeholder={this.props.t("quick_search_instructions")}
              />
              <div
                className="main-close-especial fa fa-times navbar-form-close" /* onClick={()=> this.navigateToExactPath()} */
              ></div>
            </div>
            {acction}
          </form>
          <Modal
            size="fullscreen"
            open={openModal}
            // onClose={() => dispatch({ type: 'close' })}
          >
            <Modal.Header>
              <div style={{ textAlign: "right", paddingBottom: "5px" }}>
                <Button
                  color="secondary"
                  className="button "
                  style={{
                    backgroundColor: "#ff0000",
                    color: "#fff",
                    width: "4em",
                  }}
                  onClick={this.change}
                >
                  x
                </Button>{" "}
                <Button
                  color="terceareo"
                  className="button "
                  style={{
                    color: "#fff",
                    backgroundColor: "#085fb0",
                    width: "4em",
                  }}
                  onClick={this.getCheck}
                >
                  <div className="pt-1">✓</div>
                </Button>{" "}
              </div>

              <Row>
                <Col xs={12} md={7} lg={7} style={{ paddingBottom: "5px" }}>
                  <Input
                    value={this.state.search}
                    placeholder={this.props.t("customer")}
                    onChange={this.handleSearch}
                  />
                </Col>
                <Col xs={12} md={5} lg={5} className="centerver">
                  <h5
                    style={{
                      color: "#0e0e0e",
                      fontWeight: "bold",
                    }}
                  >
                    {this.props.t("selected_customers")}: {cout}
                  </h5>
                </Col>
              </Row>
            </Modal.Header>
            <Modal.Content>
              <div
                style={{
                  overflowY: "scroll",
                  height: window.innerHeight,
                  // width: window.innerWidth > 769 ? 710 : window.innerWidth
                  // height: '230px'
                }}
                className="heightOtganizaciones"
              >
                <List
                  style={{
                    color: "black",
                    fontSize: "13px",
                    fontWeight: "bold",
                    marginBottom: "0px",
                  }}
                  as="ol"
                >
                  <List.Item as="li" value="">
                    <Checkbox
                      checked={checkAll}
                      onChange={this.checkAll}
                      value={""}
                    />
                    {this.props.t("select_all")}
                  </List.Item>
                </List>
                <div>
                  <List
                    style={{
                      color: "black",
                      fontSize: "13px",
                      fontWeight: "bold",
                    }}
                    as="ol"
                  >
                    {dataDrop.map((e, index) => {
                      if (e.hidden) {
                        return <></>;
                      } else {
                        return (
                          <div style={{ marginTop: "-10px" }}>
                            <List.Item as="ol">
                              {!openModal ? (
                                <></>
                              ) : (
                                e.data.map((f, ind) => {
                                  if (f.hidden) {
                                    return <></>;
                                  } else {
                                    return (
                                      <div
                                        className="squaredThree"
                                        style={{
                                          fontWeight: "initial",
                                          fontSize: "12px",
                                          // marginBottom: "10px"
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          value={f.id}
                                          onChange={() => {
                                            this.checkClient(index, ind);
                                          }}
                                          id={"squaredThree" + ind}
                                          name="check"
                                          checked={f.check}
                                        />

                                        <label for={"squaredThree" + ind}>
                                          <em
                                            style={{
                                              color: "#F5F5F6",
                                              margin: "2px",
                                            }}
                                            className="fas fa-check"
                                          ></em>
                                        </label>
                                        <span style={{ marginLeft: "10px" }}>
                                          {" "}
                                          {f.NIT} -- {f.value}
                                        </span>
                                      </div>
                                    );
                                  }
                                })
                              )}
                            </List.Item>
                            {index + 1 !== dataDrop.length ? (
                              <Dropdown.Divider />
                            ) : (
                              <></>
                            )}
                          </div>
                        );
                      }
                    })}
                  </List>
                </div>
              </div>
            </Modal.Content>
          </Modal>
        </nav>
      </header>
    );
  }
}
const mapStateToProps = (state) => ({
  group_list: state.header.group_list,
  notify: state.header.notify,
  clients: state.header.clients,
  nit: state.header.nit,
  lang: state.header.lang,
});
const mapDispatchToProps = (dispatch) => ({
  SetNewListGroups: (new_group_list) =>
    dispatch(SetNewListGroups(new_group_list)),
});
export default withNamespaces()(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, mapDispatchToProps)(withRouter(Header)),
  ),
);
